
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "Authorizable": [
      "ContentFolder",
      "ContentItem",
      "MediaItem"
    ],
    "Content": [
      "ContentItem",
      "MediaItem"
    ],
    "ContentSource": [
      "Design",
      "MediaItem"
    ],
    "PropertyOwner": [
      "Device",
      "Show"
    ],
    "SignalAction": [
      "SignalActionArbitrary",
      "SignalActionPlayOverlay",
      "SignalActionPlayShow",
      "SignalActionReboot",
      "SignalActionStopOverlay",
      "SignalActionTriggerView",
      "SignalActionTuneChannel"
    ],
    "Taggable": [
      "ContentItem",
      "Design",
      "Device",
      "DeviceSignal",
      "MediaItem",
      "Playlist",
      "Show"
    ],
    "Usage": [
      "ContentItem",
      "Design",
      "Playlist",
      "Show"
    ]
  }
};
      export default result;
    